export default __webpack_public_path__ + "static/media/step2.42273e1b.png";